import { defineTargetProperties } from "./target_properties";
var Controller = /** @class */function () {
  function Controller(context) {
    this.context = context;
  }
  Controller.bless = function () {
    defineTargetProperties(this);
  };
  Object.defineProperty(Controller.prototype, "application", {
    get: function get() {
      return this.context.application;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Controller.prototype, "scope", {
    get: function get() {
      return this.context.scope;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Controller.prototype, "element", {
    get: function get() {
      return this.scope.element;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Controller.prototype, "identifier", {
    get: function get() {
      return this.scope.identifier;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Controller.prototype, "targets", {
    get: function get() {
      return this.scope.targets;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Controller.prototype, "data", {
    get: function get() {
      return this.scope.data;
    },
    enumerable: true,
    configurable: true
  });
  Controller.prototype.initialize = function () {
    // Override in your subclass to set up initial controller state
  };
  Controller.prototype.connect = function () {
    // Override in your subclass to respond when the controller is connected to the DOM
  };
  Controller.prototype.disconnect = function () {
    // Override in your subclass to respond when the controller is disconnected from the DOM
  };
  Controller.targets = [];
  return Controller;
}();
export { Controller };